export { banner } from 'components/Banner/Banner.redux';
export { register } from 'containers/Register/Register.redux';

export { session } from 'components/Session/Session.redux';
export { forgot } from 'containers/ForgotPassword/ForgotPassword.redux';
export { createSAProfile } from 'components/GetUserDetails/redux';
export { SAProfilePage } from 'containers/Profile-view/redux';
export { settingStore } from 'containers/Settings/redux';
export { coachProfileView } from 'containers/CoachProfile/redux';
export { coachRegistration } from 'components/CoachRegistration/redux';
export { postingsStore } from 'components/Postings/redux';
export { dashboard } from 'components/DashboardView/redux';
export { coachDashboard } from 'containers/DashBoardCoach/redux';
export { payment } from 'containers/Payment/redux';
export { AthleteById } from 'containers/AthleteById/redux';
export { CoachAthleteView } from './../../containers/CoachAthleteView/redux';
export { admin } from 'containers/Admin/redux';
export { verifyCoach } from 'containers/VerifyCoach/redux';
export { publicAthlete } from 'containers/PublicAthletePage/redux';



// WEBPACK FOOTER //
// ./src/common/reducers/reducers.js